<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" :id="modal_name" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Sala de Procedimento</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <template v-if="internacao">
                            <div class="alert alert-info d-flex justify-content-between">
                                <div>
                                    <div v-if="internacao.paciente" class="lead">{{ internacao.paciente.st_nome }}</div>
                                    <div v-if="internacao.local">{{ internacao.local.search }}</div>
                                </div>
                                <div>#{{ internacao.id_internacao }}</div>
                            </div>

                            <div class="alert alert-success" v-if="internacao.id_local_momento && internacao.local_momento">
                                No momento em: <strong>{{ internacao.local_momento.search }}</strong>
                            </div>

                            <div v-else>
                                <az-input 
                                    placeholder="Selecione..."
                                    type="autocomplete" 
                                    optionsMode="aql"
                                    service="locals.index"
                                    :optionsSync="false"
                                    :optionsParm="{ 
                                        sala_procedimento: true
                                    }"
                                    optionsName="locals.index.sala_procedimento"
                                    label="Sala de Procedimento"
                                    required
                                    :validate="validate"
                                    v-model="internacao.local_momento" />

                                <br><br><br><br><br><br><br><br><br><br><br>
                            </div>
                        </template>

                        <template v-if="atendimento">
                            <div class="alert alert-info d-flex justify-content-between">
                                <div>Atendimento: #{{ atendimento.id_atendimento }}</div>
                                <div>
                                    <div v-if="atendimento.paciente" class="lead">{{ atendimento.paciente.st_nome }}</div>
                                </div>
                            </div>

                            <table class="table table-sm table-hover" v-if="atendimento.local_historicos.length">
                                <thead>
                                    <tr>
                                        <th>Sala</th>
                                        <th>Entrada</th>
                                        <th>Saída</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(momento, index) in atendimento.local_historicos" :key="index">
                                        <td>{{ momento.local.search }}</td>
                                        <td>{{ $util.getFormatDate(momento.dt_entrada) }} {{ momento.dt_entrada.slice(11, 16) }}</td>
                                        <td>
                                            <template v-if="momento.dt_saida">
                                                {{ $util.getFormatDate(momento.dt_saida) }} {{ momento.dt_saida.slice(11, 16) }}
                                            </template>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <div class="alert alert-success" v-if="atendimento.id_local_momento && atendimento.local_momento">
                                No momento em: <strong>{{ atendimento.local_momento.search }}</strong>
                            </div>

                            <div v-else>
                                <az-input 
                                    placeholder="Selecione..."
                                    type="autocomplete" 
                                    optionsMode="aql"
                                    service="locals.index"
                                    :optionsSync="false"
                                    :optionsParm="{ 
                                        sala_procedimento: true
                                    }"
                                    optionsName="locals.index.sala_procedimento"
                                    label="Sala de Procedimento"
                                    required
                                    :validate="validate"
                                    v-model="atendimento.local_momento" />

                                <br><br><br><br><br><br><br><br><br><br><br>
                            </div>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar()" v-if="internacao">{{ internacao.id_local_momento ? 'Registrar Saída' : 'Registrar Entrada' }}</az-submit>
                        <az-submit @click="atualizar()" v-if="atendimento">{{ atendimento.id_local_momento ? 'Registrar Saída' : 'Registrar Entrada' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() {
        return { 
            chave: "", 
            internacao: null,
            atendimento: null, 
            validate: false, 
        };
    },

    components: { 
        AzInput,
        AzSubmit,
    },

    computed: { 
        modal_name: function () { 
            return "modal_sala_proc_" + this.chave;
        }
    },

    beforeMount() {
        this.chave = this.$util.uuidv4(); 
    },

    methods: { 
        atualizar () { 
            
            if ( this.internacao ) { 

                let func = this.internacao.id_local_momento ? 'sala_procedimento_saida' : 'sala_procedimento_entrada';

                this.$util.atualizar(this, { 
                    service: 'internados',
                    func: func,
                    dados: { 
                        id_internacao: this.internacao.id_internacao, 
                        id_local: this.internacao.local_momento ? this.internacao.local_momento.id_local : null, 
                    },
                    toast: true, 
                    modal: this.modal_name,
                    callback: res => { 
                        this.$emit('refresh', res);
                    }
                });

            } else if ( this.atendimento ) {

                let func = this.atendimento.id_local_momento ? 'sala_procedimento_saida' : 'sala_procedimento_entrada';

                this.$util.atualizar(this, { 
                    service: 'atendimentos',
                    func: func,
                    dados: { 
                        id_atendimento: this.atendimento.id_atendimento, 
                        id_local: this.atendimento.local_momento ? this.atendimento.local_momento.id_local : null, 
                    },
                    toast: true, 
                    modal: this.modal_name,
                    callback: res => { 
                        this.$emit('refresh', res);
                    }
                });

            }

        },

        abrir_atend(id_atendimento) { 
            this.atendimento = null; 
            this.internacao = null; 
            this.validate = false; 

            $("#" + this.modal_name).modal("show");

            this.$util.load(this, { 
                service: 'atendimentos',
                func: 'show',
                parms: { 
                    id: id_atendimento, 
                    sala_procedimento: true, 
                },
                loadTo: res => { 
                    this.atendimento = res;
                }
            });
        },

        abrir(id_internacao) { 
            this.atendimento = null; 
            this.internacao = null; 
            this.validate = false; 

            $("#" + this.modal_name).modal("show");

            this.$util.load(this, { 
                service: 'internacaos',
                func: 'show',
                parms: { 
                    id: id_internacao, 
                    sala_procedimento: true, 
                },
                loadTo: res => { 
                    this.internacao = res;
                }
            })
        },
    }
}
</script>
